import { useLocale } from 'hooks/useLocale';
import { useNumberFormat } from 'hooks/useNumberFormat';
import { TApplication } from 'lendingApi/applications.types';

export const useFunded = (application: TApplication) => {
  const { isDE } = useLocale();
  const { formatCurrency } = useNumberFormat();
  const paidCommission = application?.paid_commission;
  const hasCommission = paidCommission && !isDE;

  const { formal_offer_sets } = application;
  const formalOfferWithLoanAgreement =
    formal_offer_sets?.[0].formal_offers?.find(
      (formal_offer) =>
        formal_offer?.loan_agreements &&
        formal_offer?.loan_agreements.length > 0,
    );
  const totalDrawdownAmount =
    formalOfferWithLoanAgreement?.total_drawdown_amount;

  return {
    totalDrawdownAmount: formatCurrency(totalDrawdownAmount),
    paidCommission: formatCurrency(paidCommission),
    hasCommission,
    isDE,
  };
};
